import { defineStore } from 'pinia'

const STATE = () => ({
  placesApiKeys: [],
  pointDistances: {},
  distanceMeasures: {},
  algorithms: {},
  periodicityOptions: {},
  dayNumberOptions: [],
  weekNumberOptions: [],
  timeZones: [],
  restoreGeogridFormState: false
})

export const useGeogridsCommonStore = defineStore('geogridsCommon', {
  state: STATE,
  actions: {
    initialize(data) {
      Object.keys(STATE()).forEach((key) => {
        if (data[key] !== undefined) this[key] = data[key]
      })
    }
  }
})
